import React from 'react'
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from '../../cvp-webgames-core/pre-caching/pre-cache-item';
import { constants } from '../../misc/constants';
import { BaseConfig } from '../BaseConfig';

import "./replay-content-ui.css"
import Button1 from '../general/button1';

class ReplayContentUICaching extends PreCacheItem {
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Image,
				key: 'rewind',
				src: process.env.PUBLIC_URL + '/assets/images/scenarios/rewind.png'
			}
		];
	}
}

export const replayContentUICaching = new ReplayContentUICaching();

const ReplayContentUI = (props: ReplayContentUIConfig) => {

	return (
		<div className="modal-disable-select center-element replay-content-ui-container" style={{
		}}>
			<Button1 props={{
				width: '100%',
				height: '100%',
				onClick: props.onReplayContentClicked,
				buttonText: props.title,
				hoverColor: constants.design.hoverColor2,
				imgSrc: replayContentUICaching.getItemByKey('rewind').src,
				imgOnRight: true,
				imgWidth: '13%',
				imgRight: '0',
				imgTextLeft: '-30px'
			}} ></Button1>
		</div>
	);

};

export interface ReplayContentUIConfig extends BaseConfig {
	title: string;
	onReplayContentClicked: () => void;
}

export default ReplayContentUI;